<template>
  <b-card-body>
    <div>
      <div>
        <small class="dep-leg w-50">Plecare:</small>
        <span class="tripInfo w-50">{{ busOutDep }}</span>
      </div>
      <!-- <div>
        <small class="dep-leg">Sosire in statiune:</small>
        <span class="tripInfo">{{ busOutArr }}</span>
      </div> -->
      <div>
        <small class="dep-leg w-50">Intoarcere:</small>
        <span span class="tripInfo w-50">{{  busInDep }}</span>
      </div>
      <!-- <div>
        <small class="dep-leg">Sosire acasa</small>
        <span class="tripInfo">{{  busInArr }}</span>
      </div>
      <div>
        <small class="dep-leg">Numar total nopti:</small>
        <span class="tripInfo">{{ busTotalNights }}</span>
      </div> -->
    </div>
  </b-card-body>
</template>

<script>
import moment from 'moment'

export default {
  name: 'BusInfo',
  props: ['result'],
  created () {
    this.busInfo = this.result.packages[0].busInfo
  },
  computed: {
    busOutDep () {
      if (!this.result.packages[0].busInfo) return null
      return this.result.packages[0].busInfo.out_departure_date
    },
    busOutArr () {
      if (!this.result.packages[0].busInfo) return null
      return this.result.packages[0].busInfo.out_arrival_date
    },
    busInDep () {
      if (!this.result.packages[0].busInfo) return null
      return this.result.packages[0].busInfo.in_departure_date
    },
    busInArr () {
      if (!this.result.packages[0].busInfo) return null
      return this.result.packages[0].busInfo.in_arrival_date
    },
    busTotalNights () {
      if (!this.result.packages[0].busInfo) return null
      const dep = moment(this.result.packages[0].busInfo.out_departure_date, 'DD-MM-YYYY')
      const ret = moment(this.result.packages[0].busInfo.in_arrival_date, 'DD-MM-YYYY')
      return ret.diff(dep, 'days')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
